import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {
  id: string = "";
  constructor(private route: ActivatedRoute){
    
  }

  ngOnInit(): void {
    this.route.paramMap
    .subscribe(params => {
      this.id = params.get("id")??"";
    })
  }
}
